export function getStreakData() {
    const count = parseInt(localStorage.getItem('streakCount') || '0', 10);
    const lastDate = localStorage.getItem('streakDate');
    return { count, lastDate };
  }
  
  export function getCurrentStreak() {
    return getStreakData().count;
  }
  
  export function updateStreak(rating) {
    if (rating <= 1) return;
  
    const today = new Date();
    const todayStr = today.toISOString().slice(0, 10);
    const { count, lastDate } = getStreakData();
  
    let newCount = count || 0;
    if (lastDate) {
      const last = new Date(lastDate);
      last.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      const diffDays = Math.floor((today - last) / (1000 * 60 * 60 * 24));
      if (diffDays >= 2) {
        newCount = 1;
      } else if (diffDays === 1) {
        newCount = count + 1;
      }
    } else {
      newCount = 1;
    }
  
    localStorage.setItem('streakCount', String(newCount));
    localStorage.setItem('streakDate', todayStr);
  
    return newCount;
  }